// src/pages/CVHome.jsx
import React from 'react';
import DashboardTile from '../components/DashboardTile';
import MessageBoard from '../components/MessageBoard';

// Define your dashboard tiles here; easy to add/remove
const tilesConfig = [
  {
    key: 'nextBooking',
    title: 'My Next Booking',
    content: (
      <>
        <p>21 Aug 2025</p>
      </>
    )
  },
  {
    key: 'status',
    title: 'Current Live Status',
    content: <p className="text-green-600 font-semibold">Available</p>
  },
  {
    key: 'nextAvailBooking',
    title: 'Next Available Booking',
    content: <p>June 15, 2025 - June 20, 2025</p>
  },
  {
    key: 'weather',
    title: 'Weather Information',
    content: <p>Sunny, 22°C</p>
  },
  {
    key: 'lastBooking',
    title: 'Last Booking By',
    content: (
      <>
        <p>Booked by: Sharon</p>
        <p>From: May 1, 2025</p>
        <p>To: May 7, 2025</p>
      </>
    )
  },
    {
    key: 'messages',
    title: 'Message Board',
    span: 'col-span-full',
    content: <MessageBoard />
  }
];

export default function CVHome() {
  const userName = 'User'; // TODO: replace with auth context

  return (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-900 p-6">
      <h1 className="text-4xl font-bold text-gray-800 dark:text-gray-100 mb-8">
        Welcome to your dashboard, {userName}
      </h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {tilesConfig.map(({ key, title, content }) => (
          <DashboardTile key={key} title={title}>
            {content}
          </DashboardTile>
        ))}
      </div>
    </div>
  );
}